import {delay} from '@@/js/utils/delay';

const cartClass = '.main-cart'
const counter = '[data-cart-count]'
const removeClass = '.remove'
const formClass = '.woocommerce-cart-form'
const cart = document.querySelector(cartClass);

const pushGtmEvent = (event) => {
  if (typeof gtm4wp_datalayer_name === 'undefined' || !window[gtm4wp_datalayer_name]) return;
  window[gtm4wp_datalayer_name].push(event);
}

document.addEventListener('click', e => {
  if (e.target.closest(removeClass)) {
    e.preventDefault()
    const row = e.target.closest('tr');
    const productData = row ? {
      name: row.querySelector('.product-name a')?.innerText?.trim(),
      price: row.querySelector('[data-price]')?.dataset?.price || row.querySelector('.product-price')?.innerText?.trim(),
      quantity: row.querySelector('.qty')?.value,
    } : {};
    removeItem(e.target.href, productData);
  }
})

const updateCounter = (html) => {
  const count = html.querySelector(counter).innerHTML;
  document.querySelector(counter).innerHTML = count;
}

const removeItem = (url, productData = {}) => {
  document.body.classList.add('is-cart-loading');
  fetch(url, {
    method: 'POST',
  })
  .then(response => response.text())
  .then(data => {
    const parser = new DOMParser().parseFromString(data, 'text/html');
    cart.innerHTML = parser.querySelector(cartClass).innerHTML;
    updateCounter(parser);
    pushGtmEvent({
      'event': 'gtm4wp.removeFromCartEEC',
      'ecommerce': {
        'currencyCode': typeof gtm4wp_currency !== 'undefined' ? gtm4wp_currency : 'AUD',
        'remove': {
          'products': [{
            'name': productData.name,
            'price': productData.price,
            'quantity': productData.quantity,
          }]
        }
      }
    });
  })
  .catch(error => {
    console.error(error);
  }).finally(() => {
    document.body.classList.remove('is-cart-loading');
  });
}

const updateCart = () => {
  const cartForm = document.querySelector(formClass);
  const formData = new FormData(cartForm);
  formData.append('update_cart', true);
  document.body.classList.add('is-cart-loading');

  fetch(`/`, {
    method: 'POST',
    body: formData,
  })
  .then(response => response.text())
  .then(data => {
    const parser = new DOMParser().parseFromString(data, 'text/html');
    cart.innerHTML = parser.querySelector(cartClass).innerHTML;
    updateCounter(parser);
    pushGtmEvent({
      'event': 'gtm4wp.cartUpdate',
    });
  })
  .catch(error => {
    console.error(error);
  }).finally(() => {
    document.body.classList.remove('is-cart-loading');
  });
}

const addToCart = (id, quantity, params) => {
  document.body.classList.add('is-cart-loading');
  const url = new URLSearchParams({
    'add-to-cart': id,
    quantity,
  }).toString();
  fetch(`${ajaxApp.homeUrl}?${url}&${params}`, {
    method: 'POST',
  }).then(response => response.text()).then(data => {
    const parser = new DOMParser().parseFromString(data, 'text/html');
    const cart = document.querySelector(cartClass);
    cart.innerHTML = parser.querySelector(cartClass).innerHTML;
    updateCounter(parser);
    pushGtmEvent({
      'event': 'gtm4wp.addToCartEEC',
      'ecommerce': {
        'currencyCode': typeof gtm4wp_currency !== 'undefined' ? gtm4wp_currency : 'AUD',
        'add': {
          'products': [{
            'id': id,
            'quantity': quantity,
          }]
        }
      }
    });
    delay(200).then(() => {
      document.body.classList.add('cart-is-open');
    })
  }).catch(error => console.error('Error:', error)).finally(() => {
    document.body.classList.remove('is-cart-loading');
  });
}

export { updateCart, addToCart };
